import type { GUIGameState } from '../../types/game-types';
import { GameplayEvents } from '../../types/game-events';
import { CONFIG } from '../../config';
import { EventsManager } from '@game-libs/events-manager';
import { unitStats } from '../../stats';
import { useCurrencyStore } from '../zustand/useCurrencyStore';
import { useDragonHealthStore } from '../zustand/useDragonHealthStore';
import { useUpgradesStore } from '../zustand/useUpgradesStore';

export const managePoisonReducer = (state: GUIGameState) => {
  const { emit } = EventsManager();
  const stats = unitStats.thief;
  const upgrades = useUpgradesStore.getState().upgrades;

  const dragonHealthSlice = useDragonHealthStore.getState();

  // Handle Poison damage and gold
  if (dragonHealthSlice.remainingPoison > 0) {
    const poisonDamage = (upgrades.thief?.blackMamba.multiplier || 0) * (stats.damagePerTick ?? 0);

    const poisonGold = poisonDamage * CONFIG.game.goldPerDamage;
    emit(GameplayEvents.POISON_DAMAGE_DRAGON, {
      damage: poisonDamage,
      gold: poisonGold,
    });

    useCurrencyStore.getState().addGold(poisonGold);

    useDragonHealthStore.getState().sync({
      remainingPoison: Math.max(dragonHealthSlice.remainingPoison - 1, 0),
      dragonHealth: Math.max(0, dragonHealthSlice.dragonHealth - poisonDamage),
    });
  }
  return state;
};
